import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Calendar: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="5"
        width="16"
        height="16"
        rx="3"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="4" y="10" width="16" height="2" fill={color} />
      <rect x="7" y="2" width="2" height="6" rx="1" fill={color} />
      <rect x="15" y="2" width="2" height="6" rx="1" fill={color} />
    </svg>
  );
};

export default Calendar;
